module.exports = __webpack_public_path__ + "static/media/Photography.50ac27cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Teafloor/Photography.jpg
// module id = 365
// module chunks = 0